import React, { useEffect, useRef, useState } from "react";
import useOnlineStatus from "../hooks/useOnlineStatus.js";

/**
 * Says so when the connection drops, instead of letting saves and lists fail
 * one toast at a time; confirms briefly when it comes back.
 */
export default function OfflineBanner() {
    const online = useOnlineStatus();
    const [justBack, setJustBack] = useState(false);
    const wasOffline = useRef(!online);

    useEffect(() => {
        if (!online) {
            wasOffline.current = true;
            setJustBack(false);
            return undefined;
        }
        if (!wasOffline.current) return undefined;
        wasOffline.current = false;
        setJustBack(true);
        const t = setTimeout(() => setJustBack(false), 3000);
        return () => clearTimeout(t);
    }, [online]);

    if (online && !justBack) return null;
    return (
        <div
            role="status"
            aria-live="polite"
            className={`offline-banner ${online ? "is-back" : ""}`}
        >
            <i className={`bi ${online ? "bi-wifi" : "bi-wifi-off"}`} aria-hidden="true" />{" "}
            {online
                ? "Back online."
                : "You're offline. Nothing can be saved or loaded until the connection is back."}
        </div>
    );
}
